// src/components/SinisterCardData/SinisterCardData.tsx

import { Box, Card, CardContent, Chip } from "@mui/material";
import { FC } from "react";
import { ISinisterRow, SinisterCardDataProps } from "../../types/fieldsconfig";
import { getStatusColorsSinister } from "../../../../shared/utils/globalColorSinister";
import { globalTranslateSinister } from "../../../../shared/utils/globalTranslateSinister";
import SinisterSectionList from "./SinisterSectionList";
import { buildSinisterSections } from "./sections";
import SinisterActions from "./SinisterActions";

interface Props extends SinisterCardDataProps {
	onUpdatePropertyClick?: () => void;
	onUpdateStatusClick?: () => void;
	responsibleName: string;
	totalBordero?: number;
	sumLmi: {
		lmiTotal: string;
		saldo: string;
		valor: number;
		valorAprovado: number;
	};
	showUpdateStatus: boolean;
	showUpdateProperty: boolean;
}

const SinisterCardData: FC<Props> = ({ row, onUpdatePropertyClick, onUpdateStatusClick, responsibleName, totalBordero, sumLmi, showUpdateStatus, showUpdateProperty }) => {
	const sections = buildSinisterSections(
		row as ISinisterRow,
		sumLmi ? { lmiTotal: sumLmi.lmiTotal, saldo: sumLmi.saldo } : { lmiTotal: "", saldo: "" },
		totalBordero ?? 0,
		responsibleName
	);

	const { bg, color } = getStatusColorsSinister(row.status);

	return (
		<Card sx={{ margin: "auto", px: 4, borderRadius: 4, ml: 1, mt: 0.5, width: "100%" }}>
			<CardContent>
				<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
					<Chip
						size="medium"
						label={` ${globalTranslateSinister(row.status)}`}
						sx={{
							color: color,
							fontWeight: 500,
							fontSize: "20px",
							background: bg,
							border: "0.5px solid #f1f1f1",
							py: 2,
						}}
					/>
					{<SinisterActions onUpdatePropertyClick={onUpdatePropertyClick} onUpdateStatusClick={onUpdateStatusClick} showButtonStatus={showUpdateStatus} showButtonProperty={showUpdateProperty} />}
				</Box>

				<SinisterSectionList sections={sections} />
			</CardContent>
		</Card>
	);
};

export default SinisterCardData;
